import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { UrlUtils } from '@atlassian/mpac-utils';
import { Either, Option } from 'funfix-core';
import { connect } from 'react-redux';
import { doInitiateUpgradeInstallModeForInstalledApp } from '../../../../../actions/Installation/UpgradeApp';
import { closeSiteUninstallDialog as _closeSiteUninstallDialog, doFetchMarketplaceAppDetails, doRevokeUserGrantGlobally, doUninstallAppFromLocalContext, doUninstallAppFromSite, openSiteUninstallDialog as _openSiteUninstallDialog } from '../../../../../actions/InstalledApps';
import ManageAppDetails from '../components/ManageAppDetails';
function getAppDetails(key, installedAppsResult) {
  return installedAppsResult.map(r => r.flatMap(iar => Option.of(iar.installedApps.find(ia => ia.details.key === key)).fold(_ => Either.left(makeDataErrorMessages(['Unable to find app'])), a => Either.right(a)))).getOrElseL(() => Either.left(makeDataErrorMessages(['Installed apps have not been initialized'])));
}
const mapStateToProps = (state, ownProps) => {
  const global = UrlUtils.resolveImmutableQuery(ownProps.location.search).get('global', 'false') === 'true';
  return {
    appData: getAppDetails(ownProps.match.params.appKey || '', global ? state.installedApps.globallyInstalledApps.result : state.installedApps.locallyInstalledApps.result),
    currentUserId: state.users.currentUserId,
    global,
    scopesLookup: state.scopes.scopesLookup,
    uninstallingAppFromSite: state.installedApps.uninstallingAppFromSite
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  closeSiteUninstallDialog: _ref => {
    let {
      installedApp
    } = _ref;
    return dispatch(_closeSiteUninstallDialog({
      installedApp
    }));
  },
  fetchMarketplaceAppDetails: _ref2 => {
    let {
      appKey,
      isGlobalContext
    } = _ref2;
    return dispatch(doFetchMarketplaceAppDetails({
      mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
      appKey,
      isGlobalContext
    }));
  },
  openSiteUninstallDialog: _ref3 => {
    let {
      installedApp
    } = _ref3;
    return dispatch(_openSiteUninstallDialog({
      installedApp
    }));
  },
  openUpgradeAppDialog: _ref4 => {
    let {
      installedApp
    } = _ref4;
    return dispatch(doInitiateUpgradeInstallModeForInstalledApp({
      mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
      installedApp
    }));
  },
  revokeUserGrantGlobally: _ref5 => {
    let {
      hostConfig,
      installedApp,
      userGrant
    } = _ref5;
    return dispatch(doRevokeUserGrantGlobally({
      hostConfig,
      installedApp,
      userGrant
    }));
  },
  uninstallAppFromSite: _ref6 => {
    let {
      installedApp,
      hostConfig,
      context
    } = _ref6;
    return dispatch(doUninstallAppFromSite({
      installedApp,
      hostConfig,
      context
    }));
  },
  uninstallAppFromLocalContext: _ref7 => {
    let {
      context,
      installedApp,
      hostConfig
    } = _ref7;
    return dispatch(doUninstallAppFromLocalContext({
      context,
      installedApp,
      hostConfig
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(ManageAppDetails);